export default {
  columnTreeList: [],
  setColumnTreeList (columnTreeList) {
    this.columnTreeList = columnTreeList
  }
}



// WEBPACK FOOTER //
// ./src/components/common/global.js